module.exports = __webpack_public_path__ + "static/media/logo-bottom.ec1c94a5.svg";